import type { ApiClient } from "@/clients/ApiClient";
import { fromEither } from "./compat";

export interface LatestParams {
    lang: string;
    /** 1 for the podcasts of the toplist only */
    onlyToplist: number;
}

export interface EpisodesApi {
    /** One page, newest first. Each episode comes with its podcast. */
    latest(params: LatestParams, page: number): Promise<Episode[]>;
    /** The episodes with these ids, newest first, each with its podcast */
    byIds(ids: number[]): Promise<Episode[]>;
}

export const createEpisodesApi = (client: ApiClient): EpisodesApi => ({
    async latest({ lang, onlyToplist }, page) {
        return fromEither<Episode[]>(
            await client.get(
                `/episodes/latest?lang=${encodeURIComponent(lang)}&page=${page}&onlyToplist=${onlyToplist}`
            ),
            "episodes"
        );
    },

    async byIds(ids) {
        return fromEither<Episode[]>(await client.get(`/episodes/collection?ids=${ids.join(",")}`), "episodes");
    },
});
